// Workstream: growth. "Share" for a winning combo: an image for WhatsApp status and Instagram stories.
import { useEffect, useRef, useState } from 'react';
import { trackEvent } from '../lib/analytics';
import { renderShareImage, shareImage, type ShareWin } from '../lib/shareImage';
import { usePrefs } from './Prefs';

export function ShareWinButton({ win, className = 'btn btn-sm btn-outline' }: { win: ShareWin; className?: string }) {
  const { toast } = usePrefs();
  const [busy, setBusy] = useState(false);
  const image = useRef<Promise<Blob> | null>(null);
  const key = JSON.stringify(win);

  // Draw the image ahead of the tap: browsers only open the share sheet straight after a tap.
  useEffect(() => {
    const p = renderShareImage(JSON.parse(key) as ShareWin);
    p.catch(() => {});
    image.current = p;
  }, [key]);

  async function share() {
    setBusy(true);
    try {
      const blob = await (image.current ?? renderShareImage(win));
      const text =
        win.kind === 'game'
          ? `${win.winner} won CompleteMasti game night \u{1F3C6} Play with us: ${location.origin}`
          : `${win.winner} won this round of CompleteMasti \u{1F602} Play with us: ${location.origin}`;
      const result = await shareImage(blob, text);
      trackEvent('share_click', { cta: `share_${win.kind}_image`, method: result });
      if (result === 'downloaded') toast('Image saved. Post it to your status!', 'success');
    } catch {
      toast('Could not make the image on this phone.', 'error');
    } finally {
      setBusy(false);
    }
  }

  return (
    <button type="button" className={className} onClick={share} disabled={busy} aria-label="Share the winning card as an image">
      {busy ? 'Making image...' : '\u{1F4F8} Share'}
    </button>
  );
}
